import useEntity from "../../hooks/useTimberClass";
import TimberClassDetail from "../../components/timberClass/TimberClassDetail/TimberClassDetail";
import TimberClassScoped from "../../components/timberClass/TimberClassDetail/TimberClassScoped";
import TimberClassTabs from "../../components/timberClass/TimberClassDetail/TimberClassTabs";
import { useGetTimberClassQuery } from "../../apis/TimberClass.api";
import { PrimaryTimberClass } from "../../types/models/TimberClass";
import React from "react";
import {Delete, Edit} from "@mui/icons-material";
import {Box, Paper, Stack, Button} from "@mui/material";
import {NavLink, useParams, useSearchParams} from "react-router";
import {useStateSession} from "../../../hooks/useAuth";
import {useTitle} from 'react-use';
import { Trans } from "@lingui/react/macro";
import { t } from "@lingui/core/macro";

const TimberClassDetailPage = () => {

    useTitle(t`Details Timber Class`);

    const session = useStateSession()
    const [searchParams] = useSearchParams();
    const scoped = searchParams.get("scoped");
    const { timberClassId: id } = useParams();

    const { data, refetch } = useGetTimberClassQuery(PrimaryTimberClass.fromPath(id))
    const { deleteTimberClass } = useEntity();

    const onDelete = React.useCallback((e: any) => {
        e.stopPropagation()
        deleteTimberClass(data, '..')
    }, [data, deleteTimberClass])

    if (id === 'scoped') {
        return (<TimberClassScoped/>)
    }

    return (
        <Box data-testid="TimberClass-details">
            { data && <Paper sx={ { padding: "2em" } }>
                <TimberClassDetail data={data} refetch={refetch} scoped={scoped}/>
                <Stack direction="row" justifyContent="center" spacing={1} sx={ { marginTop: "2em" } }>
                    
                    { (session.hasPermission(
            data.scopeGroupId,
            'applications/timber/entities/TimberClasses/update/view'
        ) ||
false) &&
                        <Button size="small" variant="outlined" data-testid="TimberClass-edit-button" startIcon={<Edit />}
                                component={NavLink}
                                to="edit"
                                relative="route"
                                viewTransition={true}
                        >
                            <Trans>Edit</Trans>
                        </Button>
                    }
                    { (session.hasPermission(
            data.scopeGroupId,
            'applications/timber/entities/TimberClasses/delete/view'
        ) ||
false) &&
                        <Button size="small" color="error" variant="outlined" data-testid="TimberClass-delete-button" startIcon={<Delete />}  onClick={(e) => onDelete(e)}>
                            <Trans>Delete</Trans>
                        </Button>
                    }
                </Stack>
            </Paper>}

            { data && <Stack direction="row" spacing={1} sx={ { marginTop: "2em" } }>
                <TimberClassTabs data={data} />
            </Stack>}
        </Box>
    )
}

export default TimberClassDetailPage;
